//@flow
import * as Immutable from 'immutable';

import {
    LatLngPolygon,
    LatLngInnerPolygon
} from 'common/models/flow/LatLngPolygon';
import type {
    LatLngPolygonModelType,
    LatLngInnerPolygonModelType
} from 'common/models/flow/LatLngPolygon';

import { LatLng } from './LatLng';

class InternalLatLngPolygon extends LatLngPolygon {
    static fromJS(json: LatLngPolygonModelType): InternalLatLngPolygon {
        const state: Object = Object.assign({}, json);
        state.vertices = Immutable.List(state.vertices).map(item =>
            LatLng.fromJS(item)
        );
        state.innerVertices = Immutable.List(state.innerVertices).map(item =>
            LatLng.fromJS(item)
        );
        state.innerPolygons = Immutable.List(state.innerPolygons).map(item =>
            InternalLatLngInnerPolygon.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    getVertices(): Array<number> {
        return this.vertices.map(vertex => [vertex.lat, vertex.lng]).toJS();
    }

    get vertices(): Immutable.List<LatLng> {
        return this._state.get('vertices');
    }

    get innerVertices(): Immutable.List<LatLng> {
        return this._state.get('innerVertices');
    }

    get innerPolygons(): Immutable.List<LatLngInnerPolygon> {
        return this._state.get('innerPolygons');
    }
}

class InternalLatLngInnerPolygon extends LatLngInnerPolygon {
    static fromJS(
        json: LatLngInnerPolygonModelType
    ): InternalLatLngInnerPolygon {
        const state: Object = Object.assign({}, json);
        state.vertices = Immutable.List(state.vertices).map(item =>
            LatLng.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    get vertices(): Immutable.List<LatLng> {
        return this._state.get('vertices');
    }
}

export {
    InternalLatLngPolygon as LatLngPolygon,
    InternalLatLngInnerPolygon as LatLngInnerPolygon
};
